import { render, staticRenderFns } from "./ResultsAccordion.vue?vue&type=template&id=ee74f082&"
import script from "./ResultsAccordion.vue?vue&type=script&lang=js&"
export * from "./ResultsAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports